<template>
  <div
    class="engineering-card__card"
    :class="cardClass"
  >
    <div class="engineering-card__tooltip">
      <sensor-icon
        :detail="detail"
        :unique-id="getUniqueId()"
      />
    </div>
    <div class="text-center">
      <span
        class="engineering-card__card-value"
        :class="{'text-red': detail.alarmed}"
      >
        {{ formatValue }}
      </span>
      <span
        class="engineering-card__card-unit"
        :class="{'text-red': detail.alarmed}"
      >
        {{ detail.unit }}
      </span>
    </div>
    <div
      class="engineering-card__card-name"
      :class="{'text-red': detail.alarmed}"
    >
      {{ detail.name }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUniqueId } from '@/services/createId';
import SensorIcon from './SensorIcon';

export default {
  name: 'EngineeringCard',
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  components: {
    SensorIcon,
  },
  computed: {
    ...mapGetters([
      'currentFontSize',
    ]),
    formatValue() {
      return this.formatNumberValue(this.detail.value) || '-';
    },
    isLargeFontSize() {
      return this.currentFontSize !== 'manage-fonts_14px';
    },
    cardClass() {
      return {
        'engineering-card__card-alarmed': this.detail.alarmed,
        'engineering-card__card-large': this.isLargeFontSize,
      };
    },
  },
  methods: {
    getUniqueId,
    formatNumberValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value);
    },
  },
};
</script>

<style lang="sass" scoped>
.engineering-card
  &__card
    position: relative
    padding: 10px
    border: 1px solid var(--color-border-dark)
    border-radius: 5px
    min-height: 160px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    &-alarmed
      border: none
      box-shadow: 0 0 3px var(--color-danger), inset 0 0 3px var(--color-danger)
    &-large
      padding: 30px 10px
  &__tooltip
    position: absolute
    top: 5px
    right: 5px
  &__card-value
    font-size: 2.5rem
  &__card-unit
    font-size: 1.8rem
  &__card-name
    text-align: center
    margin-top: 10px
    font-size: .9rem
    font-weight: bold
</style>


